export default __webpack_public_path__ + "img/eykPXJZE.a529107e.svg";